import { render, staticRenderFns } from "./IntegratedService.vue?vue&type=template&id=633e7112&scoped=true&"
import script from "./IntegratedService.vue?vue&type=script&lang=js&"
export * from "./IntegratedService.vue?vue&type=script&lang=js&"
import style0 from "./IntegratedService.vue?vue&type=style&index=0&id=633e7112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e7112",
  null
  
)

component.options.__file = "IntegratedService.vue"
export default component.exports